import React, { useEffect } from 'react';
import { Container, Header, SpaceBetween, Button } from '@amzn/awsui-components-console';
import { useLocation, useHistory } from 'react-router-dom';
import { ROUTES } from 'src/config/routeConfig';

import NavigationBreadcrumbs from './navigation/components/NavigationBreadcrumbs';
import ViewRenderer from './navigation/components/ViewRenderer';
import NavigationFlashbar from './navigation/components/NavigationFlashbar';
import { useStore } from 'src/stores/store';
import { parsePathToRoute } from './navigation/utils/navigationUtils';

const ApplicationOperationNavigation: React.FC = () => {
	const location = useLocation();
	const history = useHistory();
	const { setCurrentView, currentView } = useStore();

	useEffect(() => {
		const fullPath = location.pathname + location.hash;
		const routeInfo = parsePathToRoute(fullPath);

		setCurrentView(routeInfo.route);
	}, [location.pathname, location.hash, setCurrentView, currentView]);

	const handleViewSupportedTaskTypes = () => {
		history.push(ROUTES.SUPPORTED_TASK_TYPES);
	};

	const isRootView = location.pathname === ROUTES.APPLICATION_MANAGEMENT;

	return (
		<Container>
			<SpaceBetween direction="vertical" size="l">
				<Header
					variant="h1"
					actions={
						isRootView && (
							<Button onClick={handleViewSupportedTaskTypes}>
								View Supported Task Types
							</Button>
						)
					}
				>
					Service Registry Applications and Operations Management
				</Header>

				<NavigationFlashbar />

				<NavigationBreadcrumbs />

				<ViewRenderer />
			</SpaceBetween>
		</Container>
	);
};

export default ApplicationOperationNavigation;
